import React, { Component } from "react";

import TutorialScreen from "./TutorialScreen";

import "./Styles.scss";

class TutorialScreens extends Component {
  state = {
    fifthSlide: false,
    firstSlide: true,
    forthSlide: false,
    secondSlide: false,
    thirdSlide: false,
  };
  changeSlide = (slideNumber, action) => {
    if (slideNumber == "Slide1") {
      if (action == "next") {
        this.setState({
          fifthSlide: false,
          firstSlide: false,
          forthSlide: false,
          secondSlide: true,
          thirdSlide: false,
        });
      } else {
        this.setState({
          fifthSlide: false,
          firstSlide: true,
          forthSlide: false,
          secondSlide: false,
          thirdSlide: false,
        });
      }
    } else if (slideNumber == "Slide2") {
      if (action == "next") {
        this.setState({
          fifthSlide: false,
          firstSlide: false,
          forthSlide: false,
          secondSlide: false,
          thirdSlide: true,
        });
      } else {
        this.setState({
          fifthSlide: false,
          firstSlide: true,
          forthSlide: false,
          secondSlide: false,
          thirdSlide: false,
        });
      }
    } else if (slideNumber == "Slide3") {
      if (action == "next") {
        this.setState({
          fifthSlide: false,
          firstSlide: false,
          forthSlide: true,
          secondSlide: false,
          thirdSlide: false,
        });
      } else {
        this.setState({
          fifthSlide: false,
          firstSlide: false,
          forthSlide: false,
          secondSlide: true,
          thirdSlide: false,
        });
      }
    } else if (slideNumber == "Slide4") {
      if (action == "next") {
        this.setState({
          fifthSlide: true,
          firstSlide: false,
          forthSlide: false,
          secondSlide: false,
          thirdSlide: false,
        });
      } else {
        this.setState({
          fifthSlide: false,
          firstSlide: false,
          forthSlide: false,
          secondSlide: false,
          thirdSlide: true,
        });
      }
    } else if (slideNumber === "Slide5") {
      if (action === "next") {
        this.setState({
          fifthSlide: true,
          firstSlide: false,
          forthSlide: false,
          secondSlide: false,
          thirdSlide: false,
        });
      } else {
        this.setState({
          fifthSlide: false,
          firstSlide: false,
          forthSlide: true,
          secondSlide: false,
          thirdSlide: false,
        });
      }
    }
  };

  render() {
    let firstSlide, secondSlide, thirdSlide, forthSlide, fifthSlide;

    if (this.state.firstSlide) {
      {
        //First screen
        firstSlide = (
          <TutorialScreen
            baseRoute={this.props.baseRoute}
            btnText="Continue"
            click={this.changeSlide}
            heading="Begin Your Journey with One Step"
            next="next"
            previous="previous"
            Slide="Slide1"
            text="The Initial Assessment provides our team the best way to help understand your personal situation. Pause at any time and the Assessment will restart until complete."
            Tutorial="Tutorial_1"
          />
        );
      }
    } else if (this.state.secondSlide) {
      {
        //Second Screen
        secondSlide = (
          <TutorialScreen
            baseRoute={this.props.baseRoute}
            btnText="Continue"
            click={this.changeSlide}
            heading="You’ll Talk with Our Team Next"
            next="next"
            previous="previous"
            Slide="Slide2"
            text="After completing the Initial Assessment, we’ll work with you to identify a time for the Video Consult-ation. Our team will have a chance to talk one-to-one on your current feelings and concerns."
            Tutorial="Tutorial_2"
          />
        );
      }
    } else if (this.state.thirdSlide) {
      {
        //Third Slide
        thirdSlide = (
          <TutorialScreen
            baseRoute={this.props.baseRoute}
            btnText="Continue"
            click={this.changeSlide}
            heading="A Way Forward"
            next="next"
            previous="previous"
            Slide="Slide3"
            text="When the aptihealth team has had a chance to review every detail, we’ll be able to propose a best path scenario. This may include a unique 90 Day Care Program."
            Tutorial="Tutorial_3"
          />
        );
      }
    } else if (this.state.forthSlide) {
      //Forth Slide
      forthSlide = (
        <TutorialScreen
          baseRoute={this.props.baseRoute}
          btnText="Continue"
          click={this.changeSlide}
          heading="Feel Better Than Ever"
          next="next"
          previous="previous"
          Slide="Slide4"
          text="Our team will consult with you & your Primary Care Provider to make sure we can help in the best way. We strive to set goals that make sense for you & improve your wellbeing every time you check-in."
          Tutorial="Tutorial_4"
        />
      );
    } else if (this.state.fifthSlide) {
      //Fifth Slide
      fifthSlide = (
        <TutorialScreen
          baseRoute={this.props.baseRoute}
          btnText="Continue"
          click={this.changeSlide}
          heading="System Check"
          next="next"
          previous="previous"
          Slide="Slide5"
          text="To get started run we will run a system check to ensure you can use the latest features."
          Tutorial="setting"
        />
      );
    }

    return (
      <div className="viewTutorial">
        <div className="container">
          <div className="viewTutorial-card px-3 py-5 px-lg-5 mb-5">
            {firstSlide}
            {secondSlide}
            {thirdSlide}
            {forthSlide}
            {fifthSlide}
          </div>
        </div>
      </div>
    );
  }
}

export default TutorialScreens;
